import React from 'react';
import { loadStripe } from '@stripe/stripe-js';

// Initialize the Stripe promise
export const stripePromise = loadStripe('pk_live_51Pl0NWKv8vSBW3DpXU0v7PEv51eZOmjQ8Ncz3Iv0OWgTyj7YmUeS8JeH9zrcxG881OnRKNBVKdlIzVJVurUqwRtX00BmYOgXSb');

